import MatchHeight from "vanilla-js-match-height";
import persist from '@alpinejs/persist'
import Alpine from 'alpinejs'
import Sliders from './sliders';
import Map from './map';
import cookieStorage from './cookieStorage';

	cookieStorage();

	window.Alpine = Alpine
	Alpine.plugin(persist);
	Alpine.start()

document.addEventListener("DOMContentLoaded", function() {
	new MatchHeight(".js-notice-heading");
	new MatchHeight(".js-notice-content");
	new MatchHeight(".js-grid-heading");
	new MatchHeight(".js-grid-content");
	new MatchHeight(".js-post-heading");
	new MatchHeight(".js-post-excerpt");
	new MatchHeight(".js-card-heading");
	new MatchHeight(".js-search-title");

	Sliders();
	Map();

	let newsFilters = document.querySelectorAll('.js-filters')

	if (newsFilters) {
		newsFilters.forEach((filter) => {
			filter.addEventListener('change', () => {
				filter.closest('form').submit()
			})
		});
	}
});
